import Alpine from 'alpinejs'
import dice from './dice.js'
import './drag.js'

Alpine.data('dice', dice)
Alpine.start()
